export default (value) => (!value ? value : value.replace(/[а-яА-ЯёЁ]/g, ''));
